import { Navigate, Outlet } from "react-router-dom";
import { RootState, useAppSelector } from "../../store/root.store";

const StandardProtectedRoutes = () => {
  const isAuthenticated = useAppSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const isStandardUser = useAppSelector(
    (state: RootState) => state.auth.role === "standard"
  );

  return isAuthenticated && isStandardUser ? (
    <Outlet></Outlet>
  ) : (
    <Navigate to={`/user-login`}></Navigate>
  );
};

export default StandardProtectedRoutes;
